<div class="gw-flex gw-justify-between gw-items-center gw-p-medium">
  <h5 class="gw-m-0 gw-text-xl gw-font-semibold gw-text-text-primary">
    {{ 'features.onboarding.partnerForm.title' | translate }}
  </h5>
</div>

<div class="gw-p-medium" [formGroup]="formGroup">
  <div class="gw-mb-medium">
    <app-progressbar-stepper
      [steps]="partnerLastStepIndex + 1"
      [currentStep]="partnerStepIndex + 1"
    ></app-progressbar-stepper>
    <div class="gw-mt-x-small gw-text-xs gw-text-text-tertiary gw-text-right">
      {{ partnerStepIndex + 1 }} / {{ partnerLastStepIndex + 1 }}
    </div>
  </div>

  <!-- Step 1 -->
  <div
    *ngIf="partnerStepIndex === 0"
    class="gw-flex gw-flex-col gw-gap-x-large"
  >
    <gatewee-input-v2
      [form]="formGroup"
      controlName="name"
      [label]="'features.onboarding.partnerForm.labels.fullName' | translate"
      type="text"
      id="partner-name"
      [required]="true"
    ></gatewee-input-v2>

    <gatewee-input-v2
      [form]="formGroup"
      controlName="document"
      [label]="'features.onboarding.partnerForm.labels.cpf' | translate"
      type="text"
      id="partner-document"
      mask="000.000.000-00"
      [required]="true"
    ></gatewee-input-v2>

    <gatewee-input-v2
      [form]="formGroup"
      controlName="email"
      [label]="'features.onboarding.partnerForm.labels.email' | translate"
      type="email"
      id="partner-email"
      [required]="true"
    ></gatewee-input-v2>

    <gatewee-input-v2
      [form]="formGroup"
      controlName="phone"
      [label]="'features.onboarding.partnerForm.labels.phone' | translate"
      type="text"
      id="partner-phone"
      mask="(00)00000-0000"
      [required]="true"
    ></gatewee-input-v2>
  </div>

  <!-- Step 2 -->
  <div
    *ngIf="partnerStepIndex === 1"
    class="gw-flex gw-flex-col gw-gap-x-large"
  >
    <gatewee-input-v2
      [form]="formGroup"
      controlName="motherName"
      [label]="'features.onboarding.partnerForm.labels.motherName' | translate"
      type="text"
      id="partner-motherName"
    ></gatewee-input-v2>

    <gatewee-input-v2
      [form]="formGroup"
      controlName="socialName"
      [label]="'features.onboarding.partnerForm.labels.socialName' | translate"
      type="text"
      id="partner-socialName"
    ></gatewee-input-v2>

    <gatewee-datepicker-v2
      formControlName="birthDate"
      [label]="'features.onboarding.partnerForm.labels.birthDate' | translate"
      [required]="true"
    ></gatewee-datepicker-v2>
  </div>

  <!-- Step 3 -->
  <div *ngIf="partnerStepIndex === 2">
    <app-address-form [formGroup]="AddressFormGroup"></app-address-form>
  </div>

  <!-- Step 4 -->
  <div
    *ngIf="partnerStepIndex === 3"
    class="gw-flex gw-flex-col gw-gap-x-large"
  >
    <div>
      <gatewee-select-v3
        id="role"
        [label]="
          'features.onboarding.steps.partnersForm.inputs.role' | translate
        "
        [items]="roles"
        formControlName="role"
        [placeholder]="
          'features.onboarding.partnerForm.placeholders.role' | translate
        "
      ></gatewee-select-v3>
      <div
        class="gw-text-status-negative gw-text-sm gw-mt-x-small"
        *ngIf="formGroup.get('role')?.touched && formGroup.get('role')?.invalid"
      >
        {{ 'features.onboarding.partnerForm.validation.role' | translate }}
      </div>
    </div>

    <gatewee-input-v2
      [form]="formGroup"
      controlName="partnerSharePercentage"
      [label]="
        'features.onboarding.partnerForm.labels.sharePercent' | translate
      "
      type="text"
      id="partner-sharePercentage"
      [required]="true"
    ></gatewee-input-v2>

    <div>
      <label
        class="gw-form-label gw-block gw-mb-x-small"
        for="politicallyExposedPerson"
      >
        {{ 'features.onboarding.partnerForm.labels.pepQuestion' | translate }}
        <span class="gw-text-status-negative">*</span>
      </label>
      <div class="gw-flex gw-flex-col gw-gap-x-small">
        <gatewee-radio-button
          formControlName="politicallyExposedPerson"
          [label]="'features.onboarding.partnerForm.radio.yes' | translate"
          name="politicallyExposedPerson"
          [value]="true"
        >
        </gatewee-radio-button>
        <gatewee-radio-button
          formControlName="politicallyExposedPerson"
          [label]="'features.onboarding.partnerForm.radio.no' | translate"
          name="politicallyExposedPerson"
          [value]="false"
        >
        </gatewee-radio-button>
      </div>
      <div
        class="gw-text-status-negative gw-text-sm gw-mt-x-small"
        *ngIf="
          formGroup.get('politicallyExposedPerson')?.touched &&
          formGroup.get('politicallyExposedPerson')?.invalid
        "
      >
        {{ 'features.onboarding.partnerForm.validation.pep' | translate }}
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div class="gw-mt-medium gw-flex gw-flex-col gw-gap-small">
    <gatewee-button
      *ngIf="partnerStepIndex < partnerLastStepIndex"
      variant="primary"
      class="gw-w-full"
      [title]="'features.onboarding.shell.next' | translate"
      [disabled]="!canAdvanceFromCurrentStep()"
      (clicked)="nextPartnerStep()"
    ></gatewee-button>
    <gatewee-button
      *ngIf="partnerStepIndex === partnerLastStepIndex"
      variant="primary"
      class="gw-w-full"
      [title]="'features.onboarding.shell.finish' | translate"
      (clicked)="submit()"
    ></gatewee-button>

    <div
      class="gw-grid gw-gap-x-small"
      [class.gw-grid-cols-2]="partnerStepIndex !== 0"
      [class.gw-grid-cols-1]="partnerStepIndex === 0"
    >
      <gatewee-button
        *ngIf="partnerStepIndex !== 0"
        variant="outline"
        [title]="'features.onboarding.shell.back' | translate"
        (clicked)="previousPartnerStep()"
      ></gatewee-button>
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
      ></gatewee-button>
    </div>
  </div>
</div>
